import { render } from "./Holiday.vue?vue&type=template&id=c95286d4&scoped=true&ts=true"
import script from "./Holiday.ts?vue&type=script&lang=ts"
export * from "./Holiday.ts?vue&type=script&lang=ts"

import "./Holiday.scss?vue&type=style&index=0&id=c95286d4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c95286d4"]])

export default __exports__